<div class="modal-window__header">
  <div class="modal-window__title">
    {{ localizationConstants.LOCALIZATIONS_ADD_LANGUAGE | translate }}
  </div>
  <a (click)="modalService.close()">
    <i class="c-icon c-icon--close-dark"></i>
  </a>
</div>
<form
  #f="ngForm"
  id="modal-form"
  (ngSubmit)="submitResult({ code: code.value, language: langName.value })"
  class="o-grid--medium u-mt--medium">
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <label
      for="code"
      class="c-form-label"
      >{{ localizationConstants.LOCALIZATIONS_ISO_CODE | translate }}</label
    >
    <input
      #code="ngModel"
      ngModel
      id="code"
      name="code"
      minlength="2"
      maxlength="2"
      class="c-input c-input--alpha"
      required />
    <div
      *ngIf="code.touched && code.errors?.required"
      class="c-form-alert">
      {{ localizationConstants.LOCALIZATIONS_ISO_CODE_REQUIRED_ERROR | translate }}
    </div>
    <div
      *ngIf="code.touched && (code.errors?.minlength || code.errors?.maxlength)"
      class="c-form-alert">
      {{ localizationConstants.LOCALIZATIONS_ISO_CODE_LENGTH_ERROR | translate }}
    </div>
  </div>
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <label
      for="name"
      class="c-form-label"
      >{{ localizationConstants.LOCALIZATIONS_NAME | translate }}</label
    >
    <input
      #langName="ngModel"
      ngModel
      id="name"
      name="name"
      class="c-input c-input--alpha"
      required />
    <div
      *ngIf="langName.touched && langName.errors?.required"
      class="c-form-alert">
      {{ localizationConstants.LOCALIZATIONS_NAME_REQUIRED_ERROR | translate }}
    </div>
  </div>
  <div class="o-grid__item col-offset-6 col-3 u-mt--medium u-tablet">
    <button
      type="button"
      class="button--sm button-secondary button-block"
      (click)="modalService.close()">
      {{ localizationConstants.BUTTON_CANCEL | translate }}
    </button>
  </div>
  <div class="o-grid__item col-12 col-md-3 u-mt--medium">
    <button
      type="submit"
      class="button--sm button-primary button-block"
      [disabled]="f.invalid">
      {{ localizationConstants.BUTTON_SAVE | translate }}
    </button>
  </div>
</form>
